import { DeviceProvider } from "@/react/components/shared/BuilderUI/DeviceProvider";
import { useBuilderStore } from "@circle-react-shared/BuilderUI";
import { Preview } from "./Preview";

export const StorePreview = () => {
  const blocks = useBuilderStore(state => state.getBlocks());
  const components = useBuilderStore(state => state.getBlockRenderers());
  const canvasSize = useBuilderStore(state => state.canvasSize);

  return (
    <DeviceProvider isPreviewMode canvasSize={canvasSize}>
      <Preview block={blocks} components={components} path="blocks" />
    </DeviceProvider>
  );
};
